import { render, staticRenderFns } from "./MenuNavbarItems.vue?vue&type=template&id=28163cbd&scoped=true&"
import script from "./MenuNavbarItems.vue?vue&type=script&lang=js&"
export * from "./MenuNavbarItems.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavbarItems.vue?vue&type=style&index=0&id=28163cbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28163cbd",
  null
  
)

export default component.exports